import type {SyntheticEvent} from 'react';

export const withClose =
    (close: (e: SyntheticEvent<HTMLElement>) => void) =>
    (fn?: () => void) =>
    (e: SyntheticEvent<HTMLElement>) => {
        fn?.();
        close(e);
    };
